import { render, staticRenderFns } from "./DealContractSummary.vue?vue&type=template&id=16bf1cb6"
import script from "./DealContractSummary.vue?vue&type=script&lang=js"
export * from "./DealContractSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports